<template>
  <div class="forward-request-content-tables-component">
    <ClientOnly fallback-tag="div">
      <SiteProContentTabs />
    </ClientOnly>

    <div v-if="contentStore.activeTab === ForwardRequestTabsEnum.ReadyShipmentsTab">
      <ReadyShipmentsTable />
    </div>

    <div v-else-if="contentStore.activeTab === ForwardRequestTabsEnum.InReviewShipmentsTab" class="rounded-b-md">
      <InReviewShipmentsTable />
    </div>

    <div
      v-else-if="contentStore.activeTab === ForwardRequestTabsEnum.AllShipmentsTab"
      class="rounded-b-md xl:rounded-r-md relative xl:bg-white dark:bg-dmGray2">
      <div>
        <AllShipmentsTable />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useSiteProContentStore } from '~/store/shipzeeProContentStore'
import ReadyShipmentsTable from '~/components/SitePro/ReadyShipmentsTable.vue'
import InReviewShipmentsTable from '~/components/SitePro/InReviewShipmentsTable.vue'
import AllShipmentsTable from '~/components/SitePro/AllShipmentsTable.vue'
import ForwardRequestTabsEnum from '~/enums/ForwardRequestTabsEnum'
import SiteProContentTabs from '~/components/SitePro/SiteProContentTabs.vue'

const contentStore = useSiteProContentStore()
</script>

<style lang="postcss" scoped>
.forward-request-content-tables-component {
  @apply p-5 lg:p-5 wl:px-0;
}
</style>
